<template>
    <div>
        <div id="table_box">
            <div class="search_box">
                <el-form ref="form" :model="form" label-width="100px">
                    <el-form-item label="招标项名称：">
                        <el-input v-model="form.bidItemName" size="small"></el-input>
                    </el-form-item>
                    <el-form-item label="项目名称：">
                        <el-input v-model="form.projectName" size="small"></el-input>
                    </el-form-item>
                    <el-form-item label="招标类别：" prop="purchaseCategoryName" class="noMarginBottom">
                        <el-input v-model.trim="form.purchaseCategoryName"
                                @focus="chooseCategory"
                                size="mini"
                                readonly
                                class="minWidth"
                                placeholder="请输入招标项名称">
                            <i slot="suffix" class="iconfont iconjiansuo" @click="chooseCategory"></i>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="阶段" v-if="innerTableType == 2">
                        <el-select v-model="form.status" placeholder="请选择阶段" size="small">
                            <el-option label="邀请函" :value="1"></el-option>
                            <!-- <el-option label="发标" :value="2"></el-option> -->
                            <!-- <el-option label="标书下载" :value="3"></el-option> -->
                            <el-option label="回标" :value="4"></el-option>
                            <el-option label="定标" :value="5"></el-option>
                            <el-option label="商务谈判" :value="6"></el-option>
                            <el-option label="不参与" :value="7"></el-option>
                            <el-option label="废标" :value="8"></el-option>

                            <!-- <el-option label="邀请函" :value="1"></el-option>
                            <el-option label="回标" :value="4"></el-option>
                            <el-option label="商务谈判" :value="6"></el-option>
                            <el-option label="定标" :value="5"></el-option> -->
                        </el-select>
                    </el-form-item>
                    <el-button type="text" class="search_btn" @click="search">查询</el-button>
                </el-form>
            </div>
            <div v-if="innerTableType == 1" key="1">
                <el-table :data="tableData" :header-cell-style="tableHeaderStyle"
                          style="width: 100%">
                    <el-table-column
                        type="index"
                        label="序号"
                        width="100" align="center">
                    </el-table-column>
                    <el-table-column
                        prop="bidItemName"
                        label="招标项名称"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="projectName"
                        label="项目名称"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="purchaseCategoryName"
                        label="招标类别"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="bidStartDate"
                        label="中标时间"
                    >
                    </el-table-column>
                    <el-table-column width="200"
                                     label="操作" align="center">
                        <template slot-scope="scope">
                            <el-button type="text" @click="showDealNotification(scope.row)">查看中标通知</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div v-if="innerTableType == 2" key="2">
                <el-table :data="tableData" :header-cell-style="tableHeaderStyle"
                          style="width: 100%">
                    <el-table-column
                        type="index"
                        label="序号"
                        width="100" align="center">
                    </el-table-column>
                    <el-table-column
                        prop="bidItemName"
                        label="招标项名称"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="projectName"
                        label="项目名称"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="purchaseCategoryName"
                        label="招标类别"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="status"
                        label="招标阶段">
                        <template slot-scope="scope">
                            <span v-if="scope.row.status == 1">
                                邀请函
                            </span>
                            <span v-if="scope.row.status == 2">
                                <!-- 发标 -->
                                回标
                            </span>
                            <span v-if="scope.row.status == 3">
                                <!-- 标书下载 -->
                                回标
                            </span>
                            <span v-if="scope.row.status == 4">
                                回标
                            </span>
                            <span v-if="scope.row.status == 5">
                                定标
                            </span>
                            <span v-if="scope.row.status == 6">
                                商务谈判
                            </span>
                            <span v-if="scope.row.status == 7">
                                不参与
                            </span>
                            <span v-if="scope.row.status == 8">
                                废标
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="dealEndTime"
                        label="截止时间">
                        <template slot-scope="scope">
                            <div v-if="scope.row.dealId">
                                <span v-if="scope.row.dealSubType == 201">
                                    <span v-if="scope.row.dealEndTime">{{scope.row.dealEndTime}}</span>
                                    <span v-else>--</span>
                                </span>
                                <span v-else-if="scope.row.dealSubType == 213">
                                    <span v-if="scope.row.backEndTime">{{scope.row.backEndTime}}</span>
                                    <span v-else>--</span>
                                </span>
                                <span v-else-if="scope.row.dealSubType == 206">
                                    <span v-if="scope.row.businessEndTime">{{scope.row.dealEndTime}}</span>
                                    <span v-else>--</span>
                                </span>
                                <span v-else-if="scope.row.dealSubType == 229">
                                    <span v-if="scope.row.winBidTime">{{scope.row.winBidTime}}</span>
                                    <span v-else>--</span>
                                </span>
                                <span v-else>
                                    {{scope.row.backEndTime}}
                                </span>
                            </div>
                            <div v-else>
                                <span v-if="scope.row.status == 6">
                                    <span v-if="scope.row.businessEndTime">{{scope.row.businessEndTime}}</span>
                                    <span v-else>--</span>
                                </span>
                                <span v-else>
                                    {{scope.row.backEndTime}}
                                </span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column width="350"
                                     label="操作" align="center">
                        <template slot-scope="scope">
                            <div v-if="scope.row.dealId">
                                <span v-if="scope.row.status == 5">
                                    <!-- 中标 -->
                                    <span v-if="scope.row.subStatus == 11">
                                        <el-button type="text" @click="showDealNotification(scope.row)">查看中标通知</el-button>
                                    </span>
                                    <span v-if="scope.row.subStatus == 12&& scope.row.backBidFlag == 1">
                                        <el-button type="text" @click="showBidReturnInfo(scope.row)">查看回标信息</el-button>
                                    </span>

                                </span>
                                <span v-if="scope.row.dealSubType == 201">
                                    <el-button type="text" @click="replyInvitation(scope.row)">回复邀请函</el-button>
                                </span>
                                <span v-if="scope.row.dealSubType == 213">
                                    <el-button type="text" @click="returnBid(scope.row)">立即回标</el-button>
                                </span>
                                <span v-if="scope.row.dealSubType == 206">
                                    <el-button type="text" @click="openNegotiation(scope.row)">进入商务谈判</el-button>
                                </span>
                               <span v-if="scope.row.sendBidPublicityFlag == 1">
                                    <el-button type="text" @click="biddingPublicity(scope.row)">开标结果公示</el-button>
                                </span>
                                <span>
                                    <el-button type="text"></el-button>
                                </span>
                                <span v-if="scope.row.status >4 && scope.row.purchasePlanType <5&& scope.row.backBidFlag == 1">
                                    <el-button type="text" @click="showBidReturnInfo(scope.row)">查看回标信息</el-button>
                                </span>
                            </div>
                            <div v-else>
                                 <span v-if="scope.row.status == 5">
                                    <!-- 中标 -->
                                    <span v-if="scope.row.subStatus == 11">
                                        <el-button type="text" @click="showDealNotification(scope.row)">查看中标通知</el-button>
                                        <el-button type="text" v-if="scope.row.purchasePlanType <5&& scope.row.backBidFlag == 1" @click="showBidReturnInfo(scope.row)">查看回标信息</el-button>
                                    </span>
                                    <el-button v-else-if="scope.row.purchasePlanType <5&& scope.row.backBidFlag == 1" type="text" @click="showBidReturnInfo(scope.row)">查看回标信息</el-button>
                                </span>
                                <span v-else-if="scope.row.status >=4 && scope.row.purchasePlanType <5 && scope.row.backBidFlag == 1">
                                    <el-button type="text" @click="showBidReturnInfo(scope.row)">查看回标信息</el-button>
                                </span>
                                <span v-if="scope.row.sendBidPublicityFlag == 1">
                                    <el-button type="text" @click="biddingPublicity(scope.row)">开标结果公示</el-button>
                                </span>
                                <!-- <span v-if="scope.row.sendBusinessBidPublicityFlag == 1">
                                    <el-button type="text" @click="biddingPublicityTwo(scope.row)">二次竞价开标结果公示</el-button>
                                </span> -->
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div v-if="innerTableType == 3" key="3">
                <el-table :data="tableData" :header-cell-style="tableHeaderStyle"
                          style="width: 100%">
                    <el-table-column
                        type="index"
                        label="序号"
                        width="100" align="center">
                    </el-table-column>
                    <el-table-column
                        prop="bidItemName"
                        label="招标项名称"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="projectName"
                        label="项目名称"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="purchaseCategoryName"
                        label="招标类别"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="status"
                        label="招标阶段">
                        <template slot-scope="scope">
                            <span>邀请函</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="dealEndTime"
                        label="截止时间">
                        <template slot-scope="scope">
                            <span v-if="scope.row.dealEndTime">{{scope.row.dealEndTime}}</span>
                            <span v-else>--</span>
                        </template>
                    </el-table-column>
                    <el-table-column width="200"
                                     label="操作" align="center">
                        <template slot-scope="scope">
                            <el-button type="text" @click="replyInvitation(scope.row)">回复邀请函</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div v-if="innerTableType == 4" key="4">
                <el-table :data="tableData" :header-cell-style="tableHeaderStyle"
                          style="width: 100%">
                    <el-table-column
                        type="index"
                        label="序号"
                        width="100" align="center">
                    </el-table-column>
                    <el-table-column
                        prop="bidItemName"
                        label="招标项名称"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="projectName"
                        label="项目名称"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="purchaseCategoryName"
                        label="招标类别"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="name"
                        label="招标阶段">
                        <template slot-scope="scope">
                            <span>回标</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="date"
                        label="截止时间">
                        <template slot-scope="scope">
                            <span v-if="scope.row.backBidDelayTime">{{scope.row.backBidDelayTime}}</span>
                            <span v-else-if="scope.row.dealEndTime">{{scope.row.dealEndTime}}</span>
                            <span v-else-if="scope.row.backEndTime">{{scope.row.backEndTime}}</span>
                            <span v-else>--</span>
                        </template>
                    </el-table-column>
                    <el-table-column width="200"
                                     label="操作" align="center">
                        <template slot-scope="scope">
                            <el-button type="text" @click="returnBid(scope.row)">立即回标</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div v-if="innerTableType == 5" key="5">
                <el-table :data="tableData" :header-cell-style="tableHeaderStyle"
                          style="width: 100%">
                    <el-table-column
                        type="index"
                        label="序号"
                        width="100" align="center">
                    </el-table-column>
                    <el-table-column
                        prop="bidItemName"
                        label="招标项名称"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="projectName"
                        label="项目名称"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="purchaseCategoryName"
                        label="招标类别"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="status"
                        label="招标阶段">
                        <template slot-scope="scope">
                            <span>商务谈判</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="dealEndTime"
                        label="截止时间">
                        <template slot-scope="scope">
                            <span v-if="scope.row.dealEndTime">{{scope.row.dealEndTime}}</span>
                            <span v-else>{{scope.row.businessEndTime}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column width="200"
                                     label="操作" align="center">
                        <template slot-scope="scope">
                            <el-button type="text" @click="openNegotiation(scope.row)">进入商务谈判</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div v-if="innerTableType == 6" key="5">
                <el-table :data="tableData" :header-cell-style="tableHeaderStyle"
                          style="width: 100%">
                    <el-table-column
                        type="index"
                        label="序号"
                        width="100" align="center">
                    </el-table-column>
                    <el-table-column
                        prop="bidItemName"
                        label="招标项名称"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="projectName"
                        label="项目名称"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="purchaseCategoryName"
                        label="招标类别"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="status"
                        label="招标阶段">
                        <template slot-scope="scope">
                            <span>中标</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="dealCreateDate"
                        label="中标时间">
                        <template slot-scope="scope">
                            <span v-if="scope.row.winBidTime">{{scope.row.winBidTime}}</span>
                            <span v-else>--</span>
                        </template>
                    </el-table-column>
                    <el-table-column width="200"
                                     label="操作" align="center">
                        <template slot-scope="scope">
                            <el-button type="text" @click="showDealNotification(scope.row)">查看中标通知</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <div style="text-align: right;padding:10px 0;margin-bottom: 70px;">
                <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handlePageChange"
                    :current-page="this.form.pageNumber"
                    :page-sizes="$root.pageSizesArr"
                    :page-size="this.form.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="dataCount">
                </el-pagination>
            </div>

        </div>
        <el-dialog
            title="开标公示"
            :visible.sync="dialogVisiblePublicity"
            width="70%"
            center>
            <section class="small-container" style="margin-bottom:10px;">
                <h3 class="iconfont iconxiala">基本信息</h3>
                <el-row class="colorLine">
                    <el-col :span="10">
                        <div style="height: 1px;background: #91002c;"></div>
                    </el-col>
                    <el-col :span="14">
                        <div style="height: 1px;background: #003570;"></div>
                    </el-col>
                </el-row>
                <div style="width: 94%;margin-left: 2%;display: flex;font-size: 12px; color: #666;margin-top:20px;">
                    <div style="width:62%;">
                        <div style="margin-bottom: 20px;">招标项名称：{{springFrame.bidItemName}}</div>
                        <div style="margin-bottom: 10px;">招标单位：{{springFrame.projectName}}</div>
                    </div>
                    <div style="width:38%;text-align: left;">
                        <div style="margin-bottom: 20px;">开标时间：{{springFrame.bidEvaluateTime}}</div>
                        <!-- <div style="margin-bottom: 10px;" v-if="bidEvaluationMethod == '其他'">评标方法：{{bidEvaluationMethod}}<span>技术标：{{techRatio}}%</span><span>商务标：{{businessRatio}}%</span></div> -->
                        <div style="margin-bottom: 10px;">评标方法：{{bidEvaluationMethod}}</div>
                        <!-- <div style="margin-bottom: 10px;">评标方法：{{bidEvaluationMethod}}</div> -->
                    </div>
                </div>
            </section>
            <section class="small-container">
                <h3 class="iconfont iconxiala">开标情况</h3>
                <el-row class="colorLine">
                    <el-col :span="10">
                        <div style="height: 1px;background: #91002c;"></div>
                    </el-col>
                    <el-col :span="14">
                        <div style="height: 1px;background: #003570;"></div>
                    </el-col>
                </el-row>
            </section>
            <div style="width:97%;margin-left:2%;" v-if="(biddingStatus == 3 || biddingStatus == 4 )&& fractionUser < 65">开标说明：因技术标不合格，无法查看开标明细</div>
            <div  v-else >
                <div style="width:97%;margin-left:2%;">
                    <el-table
                        :data="comprehenseScoreRspVOS"
                        :header-cell-style="$root.tableHeaderStyle"
                        :cell-style="$root.tableCellStyle"
                        :span-method="objectSpanMethod"
                        tooltip-effect="light"
                        size="mini"
                        border
                        style="width: 100%">
                        <el-table-column label="标段" show-overflow-tooltip prop="segmentsNumber" align="center" ></el-table-column>
                        <el-table-column label="供应商名称" show-overflow-tooltip prop="supplierName" align="center" width="400">
                            <template slot-scope="scope">
                                <div :style="{color: scope.row.supplierName == '*' ? 'red' : '#0091FF'}">{{scope.row.supplierName}}</div>
                                <!-- <a href="javascript:;" style="color:#0091FF;">{{scope.row.supplierName}}</a> -->
                            </template>
                        </el-table-column>
                        <el-table-column label="综合排名" show-overflow-tooltip prop="" align="center">
                            <template slot-scope="scope">
                                <div :style="{color: scope.row.totalScoreRank == '*' ? 'red' : '#0091FF'}">{{scope.row.totalScoreRank}}</div>
                            </template>
                        </el-table-column>
                        <el-table-column label="是否超标底" show-overflow-tooltip prop="bidBaseComparision" align="center" v-if="">
                            <template slot-scope="scope">
                                <div :style="{color: scope.row.bidBaseComparision < 0 ? 'black' : 'red'}" >{{scope.row.bidBaseComparision < 0?'否': '是'}}</div>

                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <table cellspacing=1 class="mainTable" style="text-align: left;">
                    <template v-if="onlyRankFlag == 0">
                        <tr style="border-bottom:1px solid #EBEEF5;border-left:1px solid #EBEEF5;border-right:1px solid #EBEEF5;" v-for="item in comprehenseScoreRspVOSData" :key= item>
                            <td style="width:20%;" class="titleBd">标段{{item.segmentsNumber}}综合排名（1）报价：</td>
                            <td colspan="3" style="text-align: center;">{{item.backBidQuoteWithTax}}</td>
                        </tr>
                    </template>

                    <tr style="border-bottom:1px solid #EBEEF5;border-left:1px solid #EBEEF5;border-right:1px solid #EBEEF5;" v-for="item in wflowFormBidBaseSummaries" :key="item.id">
                        <td style="width:20%;" class="titleBd">标段{{item.segmentsNumber}}标底价：</td>
                        <td colspan="3" style="" v-if="inputData == 0"><el-input style="width:300px;" v-model="input" placeholder="均超标底价，不显示报价" disabled></el-input></td>
                        <td style="text-align: left;" v-if="inputData == 1" colspan="3">
                            <span>含税金额：</span><el-input size="mini" style="width:200px;" placeholder="" v-model.number="item.bidBaseAmountWithTax"></el-input>&nbsp;
                            <span>不含税金额：</span><el-input size="mini" style="width:200px;" placeholder="" v-model.number="item.bidBaseAmountExclTax"></el-input>
                        </td>
                    </tr>
                    <tr style="border-bottom:1px solid #EBEEF5;border-left:1px solid #EBEEF5;border-right:1px solid #EBEEF5;" v-if="bid">
                        <td class="titleBd" style="width:20%;">是否展示标底价：</td>
                        <td style="text-align: center;" colspan="3" >
                            <el-radio v-model="bidPriceFlag" :label="1" disabled>是</el-radio>
                            <el-radio v-model="bidPriceFlag" :label="0" disabled>否</el-radio>
                        </td>
                    </tr>
                    <!-- <tr style="border-bottom:1px solid #EBEEF5;border-left:1px solid #EBEEF5;border-right:1px solid #EBEEF5;">
                        <td class="titleBd"><span style="color:#FF4A56;">*</span>&nbsp;选择商务谈判模式</td>
                        <td colspan="3" style="text-align: center;">
                            <el-radio v-model="businessNegotiationMethod" :label="1" size="mini" disabled>全部供应商</el-radio>
                            <el-radio v-model="businessNegotiationMethod" :label="2" size="mini" disabled>逐一谈判</el-radio>
                            <el-radio v-model="businessNegotiationMethod" :label="0" size="mini" disabled>无商务谈判</el-radio>
                        </td>
                    </tr> -->
                    <!-- <tr style="border-bottom:1px solid #EBEEF5;border-left:1px solid #EBEEF5;border-right:1px solid #EBEEF5;" v-for="item in wflowFormBidBaseSummaries" :key="item.id">
                        <td style="width:15%;" class="titleBd">标段{{item.segmentsNumber}}标底价：</td>
                        <td colspan="3" style="" v-if="inputData == 0"><el-input style="width:300px;" v-model="input" placeholder="均超标底价，不显示报价" disabled></el-input></td>
                        <td style="text-align: center;" v-if="inputData == 1" colspan="3">
                            <el-input size="mini" style="width:300px;" placeholder="" v-model.number="item.bidBaseAmountWithTax"></el-input>&nbsp;
                            <el-input size="mini" style="width:300px;" placeholder="" v-model.number="item.bidBaseAmountExclTax"></el-input>
                        </td>
                    </tr> -->
                    <!-- <tr style="border-bottom:1px solid #ffffff;" v-if="bid">
                        <td class="titleBd" style="width:17%;">是否展示标底价：</td>
                        <td style="width:31.3%;" colspan="3">
                            <el-radio v-model="information.bidPriceFlag" label="1" @input="exceedingStandard">是</el-radio>
                            <el-radio v-model="information.bidPriceFlag" label="0" @input="exceedingStandard">否</el-radio>
                        </td>
                    </tr> -->
                    <!-- <tr style="border-bottom:1px solid #ffffff;">
                        <td class="titleBd"><span style="color:#FF4A56;">*</span>&nbsp;是否给供应商发送短信</td>
                        <td colspan="3">
                            <el-radio v-model="information.sendSmsFlag" label="1">是</el-radio>
                            <el-radio v-model="information.sendSmsFlag" label="0">否</el-radio>
                        </td>
                    </tr> -->
                    <tr style="border-bottom:1px solid #ffffff;" v-if="publicityRemark">
                        <td class="titleBd">备注</td>
                        <td colspan="3">
                            <el-input style="width: 900px;" type="textarea" :maxlength="500" size="mini" :rows="5" placeholder="请输入内容" v-model="publicityRemark">
                            </el-input>
                        </td>
                    </tr>

                    <tr style="border-bottom:1px solid #ffffff;">
                        <td class="titleBd" style="width:17%;">公示说明：</td>
                        <td colspan="3">
                            <p>1.本次公示结果为系统自动开标结果，技术标不合格供应商不纳入本次排名；</p>
                            <p style="color:red;font-weight: bold;">2.开标后我司将会对清单报价进行清标，对投标文件进行基础性的数据分析和整理工作。如存在严重偏离标底及市场价，取消其排名资格，视情况将偏离单位<span>列入黑名单及没收其投标保证金</span>；
                            </p>
                            <p>3.不超标底，清标后商务报价无不平衡报价或其他异常情况，则按首次排名第1单位推送定标审批，不再进行商务谈判；</p>
                            <p>4.超标底，根据各家报价情况，进入商务谈判环节，将按照排名依次进行商务谈判，综合排名以商务谈判结果重新计算；</p>
                            <p>5.最终定标单位以我司实际审批结果为准，届时可通过供应商门户中标公告查看最终中标结果。</p>
                        </td>

                    </tr>
                </table>
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="dialogVisiblePublicity = false" size="mini" style="background:#003670;border-color:#003670;">关 闭</el-button>
                <!-- <el-button type="primary" @click="determine" size="mini">确 定</el-button> -->
            </span>
        </el-dialog>
        <el-dialog
            title="二次竞价开标结果公示"
            :visible.sync="dialogVisiblePublicityTwo"
            width="70%"
            center>
            <section class="small-container" style="margin-bottom:10px;">
                <h3 class="iconfont iconxiala">基本信息</h3>
                <el-row class="colorLine">
                    <el-col :span="10">
                        <div style="height: 1px;background: #91002c;"></div>
                    </el-col>
                    <el-col :span="14">
                        <div style="height: 1px;background: #003570;"></div>
                    </el-col>
                </el-row>
                <div style="width: 94%;margin-left: 2%;display: flex;font-size: 12px; color: #666;margin-top:20px;">
                    <div style="width:62%;">
                        <div style="margin-bottom: 20px;">招标项名称：{{springFrame.bidItemName}}</div>
                        <div style="margin-bottom: 10px;">招标单位：{{springFrame.projectName}}</div>
                    </div>
                    <div style="width:38%;text-align: left;">
                        <div style="margin-bottom: 20px;">开标时间：{{springFrame.bidEvaluateTime}}</div>
                        <!-- <div style="margin-bottom: 10px;" v-if="bidEvaluationMethod == '其他'">评标方法：{{bidEvaluationMethod}}<span>技术标：{{techRatio}}%</span><span>商务标：{{businessRatio}}%</span></div> -->
                        <div style="margin-bottom: 10px;">评标方法：{{bidEvaluationMethod}}</div>
                        <!-- <div style="margin-bottom: 10px;">评标方法：{{bidEvaluationMethod}}</div> -->
                    </div>
                </div>
            </section>
            <section class="small-container">
                <h3 class="iconfont iconxiala">开标情况</h3>
                <el-row class="colorLine">
                    <el-col :span="10">
                        <div style="height: 1px;background: #91002c;"></div>
                    </el-col>
                    <el-col :span="14">
                        <div style="height: 1px;background: #003570;"></div>
                    </el-col>
                </el-row>
            </section>
            <div style="width:97%;margin-left:2%;">
                <el-table
                    :data="comprehenseScoreRspVOS"
                    :header-cell-style="$root.tableHeaderStyle"
                    :cell-style="$root.tableCellStyle"
                    :span-method="objectSpanMethod"
                    tooltip-effect="light"
                    size="mini"
                    border
                    style="width: 100%">
                    <el-table-column label="标段" show-overflow-tooltip prop="segmentsNumber" align="center" ></el-table-column>
                    <el-table-column label="供应商名称" show-overflow-tooltip prop="supplierName" align="center" width="400">
                        <template slot-scope="scope">
                            <div :style="{color: scope.row.supplierName == '*' ? 'red' : '#0091FF'}">{{scope.row.supplierName}}</div>
                            <!-- <a href="javascript:;" style="color:#0091FF;">{{scope.row.supplierName}}</a> -->
                        </template>
                    </el-table-column>
                    <el-table-column label="综合排名" show-overflow-tooltip prop="" align="center">
                        <template slot-scope="scope">
                            <div :style="{color: scope.row.totalScoreRank == '*' ? 'red' : '#0091FF'}">{{scope.row.totalScoreRank}}</div>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column label="是否超标底" show-overflow-tooltip prop="bidBaseComparision" align="center" v-if="">
                        <template slot-scope="scope">
                            <div :style="{color: scope.row.bidBaseComparision < 0 ? 'black' : 'red'}" >{{scope.row.bidBaseComparision < 0?'否': '是'}}</div>

                        </template>
                    </el-table-column> -->
                </el-table>
            </div>
            <table cellspacing=1 class="mainTable" style="text-align: left;">
                <tr style="border-bottom:1px solid #EBEEF5;border-left:1px solid #EBEEF5;border-right:1px solid #EBEEF5;" v-for="item in comprehenseScoreRspVOSData" :key= item>
                    <td style="width:20%;" class="titleBd">标段{{item.segmentsNumber}}综合排名（1）报价：</td>
                    <td colspan="3" style="text-align: center;">{{item.backBidQuoteWithTax}}</td>
                </tr>
                <tr style="border-bottom:1px solid #ffffff;">
                    <td class="titleBd" style="width:17%;">公示说明：</td>
                    <td colspan="3">
                        <p>1.本次公示结果为系统自动开标结果，技术标不合格供应商不纳入本次排名；</p>
                        <p style="color:red;font-weight: bold;">2.开标后我司将会对清单报价进行清标，对投标文件进行基础性的数据分析和整理工作。如存在严重偏离标底及市场价，取消其排名资格，视情况将偏离单位<span>列入黑名单及没收其投标保证金</span>；
                        </p>
                        <p>3.不超标底，清标后商务报价无不平衡报价或其他异常情况，则按首次排名第1单位推送定标审批，不再进行商务谈判；</p>
                        <p>4.超标底，根据各家报价情况，进入商务谈判环节，将按照排名依次进行商务谈判，综合排名以商务谈判结果重新计算；</p>
                        <p>5.最终定标单位以我司实际审批结果为准，届时可通过供应商门户中标公告查看最终中标结果。</p>
                    </td>

                </tr>
            </table>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="dialogVisiblePublicityTwo = false" size="mini" style="background:#003670;border-color:#003670;">关 闭</el-button>
            </span>
        </el-dialog>
        <select-category ref="selectCategory" @callback="selectedCategory"></select-category>
    </div>
</template>
<script type="text/babel">
    export default {
        name: 'bidTable',
        data(){
            return {
                dialogVisiblePublicity: false,
                dialogVisiblePublicityTwo: false,
                biddingStatus: '', //招标状态
                fractionUser: '', //分数
                // supplierId: window.sessionStorage.getItem(loginId),
                information: {
                    sendSmsFlag: '',
                    sendBidPublicityFlag: '',
                    bidPriceFlag: 0,
                    flowFormId: this.$route.params.formId,
                    bidBaseAmountWithTax: '',
                    bidBaseAmountExclTax: '',
                    segmentsNumber: '',
                    wFlowFormBidPublicityList: []
                },
                businessNegotiationMethod: 0,
                exceedingBasePriceFlag: [],
                bid: false,
                input: '',
                inputData: 0,
                comprehenseScoreRspVOSData: [],
                wflowFormBidBaseSummariesData: [],
                userType:'',
                timeFlag: '',
                purchaseItemName: '',
                segmentsNumber: '',
                buttonShow: true,
                flowFormId: '',
                flowToDoId: '',
                answerTime: '',
                questionTime: '',
                tableData: [],
                baseInfo: {
                    attachmentList: [],
                    bidEvaluationTecRatio:'',
                    bidEvaluationBusinessRatio:'',
                },
                labelWidth: '200px',
                extensionTableData: [],//延时
                delayTime: '',
                calibrationInfoRspVOS: [],
                comprehenseScoreRspVOS: [],
                wFlowFormBidEvaluateTeams: [],
                supplierColumnList: [],
                wflowFormTechScores: [],
                scoreShow:false,
                flowForm: {},
                dialogTableVisible: false,
                dialogTableData: [],
                innerSupplierColumnList: [],
                innerType:0,
                activeSupplierName:"",
                scoreInstructions:"",
                wflowFormInfo:{},
                wflowFormBidBaseSummaries:[],
                bidEvaluationEndTime:'',
                editFlag:false,
                baseSummaryForm:{
                    bidBaseAmountSegment1: '',
                    bidBaseAmountSegment2: '',
                },
                flowFormRules:{
                    bidBaseAmountSegment1: [
                    {
                        required: true,
                        message: '请输入标段1的预估金额',
                        trigger: 'blur'
                    },
                    // {validator: this.checkDeg, trigger: 'blur'}
                    ],
                    bidBaseAmountSegment2: [
                    {
                        required: true,
                        message: '请输入标段2的预估金额',
                        trigger: 'blur'
                    },
                    // {validator: this.checkDeg, trigger: 'blur'}
                    ],
                },
                hasBaseSummaryPrice:'',
                bidEvaluationAttachs: [],//提交审批附件
                formId:'',
                hideButton:false,
                categoryCode: '',
                parentCategoryCode:'',
                sendBidPublicityFlag: 0,
                springFrame: {},
                // bid: false,
                // input4: '',
                // input5: '',
                // input: '',
                // inputData: 0,
                form: {
                    bidItemName: '',
                    projectName: '',
                    dealSubType: '',

                    purchaseCategoryId: '',
                    purchaseCategoryName: '',

                    allFlag: '',

                    pageFlag: 1,
                    pageNumber: 1,
                    pageSize: 10,
                },
                // tableData: [],
                tableHeaderStyle:{
                    'background-color': '#F6F6F6',
                    'height': '40px',
                    'color': '#333333',
                },
                innerTableType: 1,
                dataCount: 0,
                bidEvaluationMethod: '',
                bidPriceFlag: '',
                xianshiData: [],
                // input: '',
                // inputData: 0,
                publicityRemark:'', // 备注
                onlyRankFlag:'', // 是否只展示排名
            }
        },
        components: {
        },
        created(){
            this.getData();
            console.log(window.sessionStorage.getItem('loginId'))
        },
        props:{
//            innerTableType:{
//                type: Number
//            }
        },
        methods:{
            // 招标公示
            biddingPublicity(row) {
                // console.log(row)
                this.springFrame = row
                this.comprehenseScoreRspVOS = []
                this.dialogVisiblePublicity = true
                let that = this
                this.$root.getFunc('/v1/formflowHS/getBidEvaluationConclusion?flowFormId=' + row.id, (res) => {
                    let data = res.data.data
                    this.businessNegotiationMethod = res.data.data.wflowFormInfo.businessNegotiationMethod
                    this.bidPriceFlag = res.data.data.wflowFormInfo.bidPriceFlag;
                    this.onlyRankFlag = res.data.data.wflowFormInfo.onlyRankFlag;  // 是否只展示排名
                    this.publicityRemark = res.data.data.wflowFormInfo.publicityRemark; // 备注
                    if (this.bidPriceFlag == 0){
                        this.inputData = 0
                    } else {
                      this.inputData = 1
                    }
                    // console.log(this.businessNegotiationMethod,'谈判模式')
                    if (data.wflowFormBidBaseSummaries) {
                        data.wflowFormBidBaseSummaries.forEach((item,index)=>{
                            item.bidBaseAmountWithTax = that.$root.rounding(item.bidBaseAmountWithTax)
                            item.bidBaseAmountExclTax = that.$root.rounding(item.bidBaseAmountExclTax)
                            item.bidBaseTaxAmount = that.$root.rounding(item.bidBaseTaxAmount)
                        })
                    }
                    // console.log(data.comprehenseScoreRspVOS)
                    if (data.comprehenseScoreRspVOS) {
                        data.comprehenseScoreRspVOS.forEach((item)=>{
                            let startRowIndex = 0, endRowIndex = 0;
                            if (item.wflowFormComprehenseScores) {
                                item.wflowFormComprehenseScores.forEach((val, i, arr)=>{
                                    // console.log(val, i,arr)
                                    val.bidBusinessAmount = that.$root.rounding(val.bidBusinessAmount)
                                    if(i === 0){
                                        startRowIndex = this.comprehenseScoreRspVOS.length;
                                        endRowIndex = this.comprehenseScoreRspVOS.length + arr.length - 1;
                                        val.startColIndex = 0;
                                        val.endColIndex = 0;
                                        val.startRowIndex = startRowIndex;
                                        val.endRowIndex = endRowIndex;
                                    }else{
                                        val.startColIndex = 0;
                                        val.endColIndex = 0;
                                        val.startRowIndex = startRowIndex;
                                        val.endRowIndex = endRowIndex;
                                    }
                                    this.comprehenseScoreRspVOS.push(val);
                                });
                            }
                        })
                        // 去重
                        let newArr = []
                        newArr.push(this.comprehenseScoreRspVOS[0] || '')
                        // console.log(newArr)
                        this.comprehenseScoreRspVOS.forEach((item,index) => {
                            if(index > 0) {
                                if(item.segmentsNumber != newArr[newArr.length - 1].segmentsNumber) {
                                    newArr.push(item)
                                }
                            }
                        })
                        this.comprehenseScoreRspVOS.forEach(val =>{
                            if(val.supplierId == window.sessionStorage.getItem('loginId')) {
                                this.fractionUser = val.bidTechnicalScore
                            }
                        })
                        // console.log(newArr)
                        // 过滤删选出来有没有超标底的
                        this.comprehenseScoreRspVOSData = newArr.filter(item => {
                            return item.bidBaseComparision < 0
                        })
                        // console.log(this.comprehenseScoreRspVOSData)
                        // console.log(this.comprehenseScoreRspVOSData,'this.comprehenseScoreRspVOS')
                        // if (this.xianshiData) {
                        //     this.wflowFormBidBaseSummariesData = this.xianshiData.filter(item => {
                        //         return segmentsNumberArr.indexOf(item.segmentsNumber) < 0
                        //     })
                        // }
                        // // console.log('评标2',this.wflowFormBidBaseSummariesData)
                        // this.xianshiData =JSON.parse(JSON.stringify(this.wflowFormBidBaseSummariesData))
                        // // console.log(segmentsNumberArr)
                        // }
                        // // console.log('评标3',this.xianshiData)
                        // if(this.xianshiData.length >= 1) {
                        //     this.bid = true
                        // }
                        // if (this.comprehenseScoreRspVOSData.length) {
                        //     let noArr = []
                        //     this.comprehenseScoreRspVOSData.forEach(item => noArr.push(item.segmentsNumber))
                        //     console.log(noArr,'12345')
                        //     this.comprehenseScoreRspVOS.forEach((item) => {
                        //         if (noArr.indexOf(item.segmentsNumber) < 0) {
                        //             if (item.supplierId != window.sessionStorage.getItem('loginId')) {
                        //                 item.supplierName = '*'
                        //                 item.businessRank = '*'
                        //             }
                        //         }
                        //     })
                        // } else {
                            this.comprehenseScoreRspVOS.forEach((item) => {
                                if (item.supplierId != window.sessionStorage.getItem('loginId')) {
                                    item.supplierName = '*'
                                    // item.businessRank = '*'
                                    item.totalScoreRank = '*'
                                }
                            })
                        // }
                        let segmentsNumberArr = []
                        this.comprehenseScoreRspVOSData.forEach((item) => {
                            segmentsNumberArr.push(item.segmentsNumber)
                        })
                        this.wflowFormBidBaseSummariesData = data.wflowFormBidBaseSummaries.filter(item => {
                            return segmentsNumberArr.indexOf(item.segmentsNumber) < 0
                        })
                        this.wflowFormBidBaseSummaries =JSON.parse(JSON.stringify(this.wflowFormBidBaseSummariesData))
                        // console.log(segmentsNumberArr)
                    }
                    // console.log(data.comprehenseScoreRspVOS)
                    this.bidEvaluationMethod = data.wflowFormInfo.bidEvaluationMethod
                    this.biddingStatus = data.wflowFormInfo.bidEvaluationMethod
                    if (data.wflowFormInfo.bidEvaluationMethod == 1) {
                        this.bidEvaluationMethod = '免评技术标'
                    } else if (data.wflowFormInfo.bidEvaluationMethod == 2) {
                        this.bidEvaluationMethod = '合理低价法'
                    } else if (data.wflowFormInfo.bidEvaluationMethod == 3) {
                        this.bidEvaluationMethod = '综合评分法1'
                    } else if (data.wflowFormInfo.bidEvaluationMethod == 4) {
                        this.bidEvaluationMethod = '综合评分法2'
                    } else if (data.wflowFormInfo.bidEvaluationMethod == 5) {
                        this.techRatio = res.data.data.wflowFormInfo.techRatio
                        this.businessRatio = res.data.data.wflowFormInfo.businessRatio
                        this.bidEvaluationMethod = '其他' + ':' + '技术标' + '：' + this.techRatio + '%' + ';' + '商务标' + '：' + this.businessRatio + '%'
                        // this.bidEvaluationMethod = '其他' + ':'
                    }
                    // if (data.wflowFormInfo.bidEvaluationMethod == 5) {
                    //     this.techRatio = data.wflowFormInfo.techRatio
                    //     this.businessRatio = data.wflowFormInfo.businessRatio
                    // }
                    // console.log(this.wflowFormBidBaseSummaries,'this.wflowFormBidBaseSummaries')
                    if(this.wflowFormBidBaseSummaries.length > 0) {
                        this.bid = true
                    } else {
                        this.bid = false
                    }
                })
            },
            biddingPublicityTwo(row){
                this.springFrame = row
                this.comprehenseScoreRspVOS = []
                this.dialogVisiblePublicityTwo = true
                let that = this
                this.$root.getFunc('/v1/formflowHS/getBidEvaluationConclusion?flowFormId=' + row.id, (res) => {
                    let data = res.data.data
                    this.businessNegotiationMethod = res.data.data.wflowFormInfo.businessNegotiationMethod
                    this.bidPriceFlag = res.data.data.wflowFormInfo.bidPriceFlag
                    if (this.bidPriceFlag == 0){
                        this.inputData = 0
                    } else {
                      this.inputData = 1
                    }
                    // console.log(this.businessNegotiationMethod,'谈判模式')
                    if (data.wflowFormBidBaseSummaries) {
                        data.wflowFormBidBaseSummaries.forEach((item,index)=>{
                            item.bidBaseAmountWithTax = that.$root.rounding(item.bidBaseAmountWithTax)
                            item.bidBaseAmountExclTax = that.$root.rounding(item.bidBaseAmountExclTax)
                            item.bidBaseTaxAmount = that.$root.rounding(item.bidBaseTaxAmount)
                        })
                    }
                    // console.log(data.comprehenseScoreRspVOS)
                    if (data.comprehenseScoreRspVOS) {
                        data.comprehenseScoreRspVOS.forEach((item)=>{
                            let startRowIndex = 0, endRowIndex = 0;
                            if (item.wflowFormComprehenseScores) {
                                item.wflowFormComprehenseScores.forEach((val, i, arr)=>{
                                    // console.log(val, i,arr)
                                    val.bidBusinessAmount = that.$root.rounding(val.bidBusinessAmount)
                                    if(i === 0){
                                        startRowIndex = this.comprehenseScoreRspVOS.length;
                                        endRowIndex = this.comprehenseScoreRspVOS.length + arr.length - 1;
                                        val.startColIndex = 0;
                                        val.endColIndex = 0;
                                        val.startRowIndex = startRowIndex;
                                        val.endRowIndex = endRowIndex;
                                    }else{
                                        val.startColIndex = 0;
                                        val.endColIndex = 0;
                                        val.startRowIndex = startRowIndex;
                                        val.endRowIndex = endRowIndex;
                                    }
                                    this.comprehenseScoreRspVOS.push(val);
                                });
                            }
                        })
                        // 去重
                        let newArr = []
                        newArr.push(this.comprehenseScoreRspVOS[0] || '')
                        // console.log(newArr)
                        this.comprehenseScoreRspVOS.forEach((item,index) => {
                            if(index > 0) {
                                if(item.segmentsNumber != newArr[newArr.length - 1].segmentsNumber) {
                                    newArr.push(item)
                                }
                            }
                        })
                        // console.log(newArr)
                        // 过滤删选出来有没有超标底的
                        this.comprehenseScoreRspVOSData = newArr.filter(item => {
                            return item.bidBaseComparision < 0
                        })
                        // console.log(this.comprehenseScoreRspVOSData)
                        // console.log(this.comprehenseScoreRspVOSData,'this.comprehenseScoreRspVOS')
                        // if (this.xianshiData) {
                        //     this.wflowFormBidBaseSummariesData = this.xianshiData.filter(item => {
                        //         return segmentsNumberArr.indexOf(item.segmentsNumber) < 0
                        //     })
                        // }
                        // // console.log('评标2',this.wflowFormBidBaseSummariesData)
                        // this.xianshiData =JSON.parse(JSON.stringify(this.wflowFormBidBaseSummariesData))
                        // // console.log(segmentsNumberArr)
                        // }
                        // // console.log('评标3',this.xianshiData)
                        // if(this.xianshiData.length >= 1) {
                        //     this.bid = true
                        // }
                        // if (this.comprehenseScoreRspVOSData.length) {
                        //     let noArr = []
                        //     this.comprehenseScoreRspVOSData.forEach(item => noArr.push(item.segmentsNumber))
                        //     console.log(noArr,'12345')
                        //     this.comprehenseScoreRspVOS.forEach((item) => {
                        //         if (noArr.indexOf(item.segmentsNumber) < 0) {
                        //             if (item.supplierId != window.sessionStorage.getItem('loginId')) {
                        //                 item.supplierName = '*'
                        //                 item.businessRank = '*'
                        //             }
                        //         }
                        //     })
                        // } else {
                            this.comprehenseScoreRspVOS.forEach((item) => {
                                if (item.supplierId != window.sessionStorage.getItem('loginId')) {
                                    item.supplierName = '*'
                                    // item.businessRank = '*'
                                    item.totalScoreRank = '*'
                                }
                            })
                        // }
                        let segmentsNumberArr = []
                        this.comprehenseScoreRspVOSData.forEach((item) => {
                            segmentsNumberArr.push(item.segmentsNumber)
                        })
                        this.wflowFormBidBaseSummariesData = data.wflowFormBidBaseSummaries.filter(item => {
                            return segmentsNumberArr.indexOf(item.segmentsNumber) < 0
                        })
                        this.wflowFormBidBaseSummaries =JSON.parse(JSON.stringify(this.wflowFormBidBaseSummariesData))
                        // console.log(segmentsNumberArr)
                    }
                    // console.log(data.comprehenseScoreRspVOS)
                    this.bidEvaluationMethod = data.wflowFormInfo.bidEvaluationMethod
                    if (data.wflowFormInfo.bidEvaluationMethod == 1) {
                        this.bidEvaluationMethod = '免评技术标'
                    } else if (data.wflowFormInfo.bidEvaluationMethod == 2) {
                        this.bidEvaluationMethod = '合理低价法'
                    } else if (data.wflowFormInfo.bidEvaluationMethod == 3) {
                        this.bidEvaluationMethod = '综合评分法1'
                    } else if (data.wflowFormInfo.bidEvaluationMethod == 4) {
                        this.bidEvaluationMethod = '综合评分法2'
                    } else if (data.wflowFormInfo.bidEvaluationMethod == 5) {
                        this.techRatio = res.data.data.wflowFormInfo.techRatio
                        this.businessRatio = res.data.data.wflowFormInfo.businessRatio
                        this.bidEvaluationMethod = '其他' + ':' + '技术标' + '：' + this.techRatio + '%' + ';' + '商务标' + '：' + this.businessRatio + '%'
                        // this.bidEvaluationMethod = '其他' + ':'
                    }
                    // if (data.wflowFormInfo.bidEvaluationMethod == 5) {
                    //     this.techRatio = data.wflowFormInfo.techRatio
                    //     this.businessRatio = data.wflowFormInfo.businessRatio
                    // }
                    // console.log(this.wflowFormBidBaseSummaries,'this.wflowFormBidBaseSummaries')
                    if(this.wflowFormBidBaseSummaries.length > 0) {
                        this.bid = true
                    } else {
                        this.bid = false
                    }
                })
            },
            // 合并
            objectSpanMethod(cell) {
                let rowNum = 1, colNum = 1;
                if(cell.rowIndex >= cell.row.startRowIndex && cell.rowIndex <= cell.row.endRowIndex && cell.columnIndex >= cell.row.startColIndex && cell.columnIndex <= cell.row.endColIndex){
                    if(cell.rowIndex == cell.row.startRowIndex && cell.columnIndex == cell.row.startColIndex){
                        rowNum = cell.row.endRowIndex - cell.row.startRowIndex + 1;
                        colNum = cell.row.endColIndex - cell.row.startColIndex + 1;
                    }else{
                        rowNum = 0;
                        colNum = 0;
                    }
                }
                return [rowNum, colNum];
            },
            showBidReturnInfo(row){
                if(row.purchasePlanType == 3 || row.purchasePlanType == 4){
                    this.$router.push('/bidReturnHigher/'+row.id+'?type=1');
                }else {
                    this.$router.push('/bidReturnLower/'+row.id+'?type=1');
                }
            },
            replyInvitation(row){
                this.$router.push('/invitation/'+row.dealId);
            },
            returnBid(row){
                // let obj = {
                //     dealId: row.dealId,
                //     wFlowFormId: row.id,
                // }
                // this.$emit('showWinBid', obj);
                // return;
                if(row.purchasePlanType == 3 || row.purchasePlanType == 4){
                    this.$router.push('/bidReturnHigher/'+row.dealId);
                }else {
                    this.$router.push('/bidReturnLower/'+row.dealId);
                }
            },
            openNegotiation(row){
                this.$router.push('/businessNegotiation/'+row.dealId);
            },
            showDealNotification(row){
                // this.$router.push('/invitation/'+row.dealId);
                let obj = {
                    dealId: row.dealId,
                    wflowFormId: row.id,
                }
                this.$emit('showWinBid', obj);
            },
            search(){
                this.form.pageNumber = 1;
                this.getData();
            },
            handlePageChange(val){
                let that = this;
                that.form.pageNumber = val;
                that.getData();
            },
            handleSizeChange(val){
                let that = this;
                that.form.pageSize = val;
                that.form.pageNumber = 1;
                that.getData();
            },
            selectedCategory(val){
                this.form.purchaseCategoryId = val.id;
                this.form.purchaseCategoryName = val.categoryName;
            },
            chooseCategory(){
                this.$refs['selectCategory'].show();
            },
            resetSearch(){
                this.form = {
                    bidItemName: '',
                    projectName: '',
                    dealSubType: '',

                    purchaseCategoryId: '',
                    purchaseCategoryName: '',

                    status: '',
                    allFlag: '',

                    pageFlag: 1,
                    pageNumber: 1,
                    pageSize: 10,
                };
            },
            getData(){
                let that = this;
                let params = Object.assign({}, this.form);

                let url = '/v1/outerformflowHS/getMyFormList';
                if(this.innerTableType == 2 || this.innerTableType == 1){
                    url = '/v1/outerformflowHS/getAllBidFormList';
                    if(this.innerTableType == 1){
                        params.status = 5;
                        params.subStatus = 11;
                    }

                }else {
                    params = Object.assign({}, {dealType: 2}, this.form);
                    delete params.status;
                }


                this.$root.postHttp(url, params, (res) => {
                    that.tableData = res.data.data.list;
                    that.dataCount = res.data.data.count;
                });
            },
            changeType(innerTableType){
                this.resetSearch();
                this.innerTableType = innerTableType;
                if(this.innerTableType == 1){
                    this.form.dealSubType = '229';
                }else if(this.innerTableType == 2){
                    this.form.dealSubType = '';
                }else if(this.innerTableType == 3){
                    this.form.dealSubType = 201;
                    this.form.allFlag = 1;
                }else if(this.innerTableType == 4){
                    this.form.dealSubType = 213;
                }else if(this.innerTableType == 5){
                    this.form.dealSubType = 206;
                }else if(this.innerTableType == 6){
                    this.form.dealSubType = 229;
                }else {
                    this.form.dealSubType = '';
                }
                // console.log(innerTableType)
                this.getData();
            }
        }
    }
</script>
<style lang="scss" scoped>
    @import '../assets/_var.scss';
    .search_box{
        text-align: left;
        .el-form-item /deep/{
            width: 270px;
            display: inline-block;
            .el-input__inner{
                border-radius: 0!important;
            }
        }
        .search_btn{
            color: #333333;
            font-size: 16px;
            margin-left: 10px;
        }
    }
     .iconxiala::before {
        position: absolute;
        left: -5px;
        font-size: 20px;
    }

    .colorLine {
        margin-top: 10px;
        margin-bottom: 20px;
        padding-left: 20px;
    }
    // 招标公示
        .mainTable {
            width: 97%;
            margin-left: 2%;
            border-color: #D6D6D6;
            font-size: 12px;
            color: #666;
            // margin: 20px;
            caption {
            margin-bottom: 10px;
        }
        /deep/ .el-input__inner {
            border: none;
            font-size: 12px;
            text-align: center;
        }
        /deep/ .el-input.is-disabled .el-input__inner {
            background: #fff;
            color: red !important;
        }
        // s
        h1 {
            font-size: 15px;
            color: #373737;
            text-align: center;
        }

        p {
            margin: 0;
            padding: 0;
            // text-indent: 2em;
        }

        a {
            margin: 10px;
            color: #53a4fe;
            text-decoration: none;
            padding-bottom: 2px;
            border-bottom: #D0E4FF 2px solid;
        }

        .titleBc {
            background-color: rgb(246, 246, 246);
            // background-color: #F7F9FD;
            color: #434343;
            text-align: center;
            font-weight: bold;
        }
        .titleBd {
            // background-color: #F7F9FD;
            // color: #434343;
            // border:1px solid red;
            text-align: left;
            color: #666;
            // text-align: center;
            font-weight: bold;
        }

        td {
            padding: 10px 20px;
        }

        .table2 td {
            padding: 1px 70px 1px 6px;
        }

        // .table3 td {
        //     padding: 0 2px 1px 6px;
        // }

        .liucheng {
            padding: 4px 8px;
            border: 1px solid #53a4fe;
            color: #53a4fe;
            border-radius: 4px;
        }

        .borderBottom td {
            border-bottom: 2px solid #53a4fe;
        }

        // .dot {
        //     position: relative;
        //     border-right: 1px solid #53a4fe;
        // }

        // .dot::after {
        //     display: block;
        //     color: #53a4fe;
        //     content: "";
        //     width: 5px;
        //     height: 5px;
        //     border-radius: 50%;
        //     background-color: #53a4fe;
        //     position: absolute;
        //     bottom: -3px;
        //     right: -3px;
        // }
        }
        h3 {
        // background-color: #ececec;
        padding: 0 20px 5px;
        margin: 0;
        // margin-top: 10px;
        position: relative;
        cursor: pointer;
    }
        /////
    #table_box /deep/{
        .table_header th{
            background-color: #F6F6F6!important;
        }

        .el-table th, .el-table td {
            padding: 0px 0;
            font-size: 12px;
        }

        .el-table__body-wrapper {
            font-size: 12px;
        }
        .el-button.el-button--text {
            font-size: 12px;
            padding: 0px;
        }

        .el-table .cell {
            line-height: 32px;
        }
    }


</style>



// WEBPACK FOOTER //
// src/components/bidTable.vue